class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init();

    const resizeObserver = new ResizeObserver(() => this.update());
    resizeObserver.observe(this);

    this.navItems.forEach(item =>
      item.addEventListener('click', this.onNavItemClick.bind(this))
    );

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    window.addEventListener('message', this.onVariantChange.bind(this));
  }

  init() {
    this.imagesContainer = this.querySelector('.product-gallery__images');
    this.navItems = this.querySelectorAll('.product-gallery__nav-item');
    this.images = this.querySelectorAll('.product-gallery__image');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (this.findCurrentIndex() === -1 && this.images.length > 0) {
      this.setCurrentImage(this.images[0]);
    }
  }

  onVariantChange(event) {
    if (!event.data || event.data.type !== 'variant_changed') return;
    const currentImage = Array.from(this.images).find(
      item => item.dataset.mediaId == event.data.variant.featured_media.id
    );
    if (currentImage) {
      this.setCurrentImage(currentImage);
    }
  }

  onNavItemClick(event) {
    const mediaId = event.target.closest('li').dataset.mediaId;
    this.setCurrentImage(
      Array.from(this.images).find(item => item.dataset.mediaId === mediaId)
    );
  }

  update() {
    if (!this.prevButton || !this.nextButton) return;

    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');

    const index = this.findCurrentIndex();
    if (index === 0) this.prevButton.setAttribute('disabled', true);
    if (index === this.images.length - 1) this.nextButton.setAttribute('disabled', true);
  }

  setCurrentImage(elem) {
    this.images.forEach(item =>
      item.classList.remove('product-gallery__image--active')
    );
    elem.classList.add('product-gallery__image--active');
    this.update();
  }

  findCurrentIndex() {
    return Array.from(this.images).findIndex(item =>
      item.classList.contains('product-gallery__image--active')
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    let index = this.findCurrentIndex();

    if (event.currentTarget.name === 'next') {
      index++;
    } else {
      index--;
    }

    if (index >= 0 && index < this.images.length) {
      this.setCurrentImage(this.images[index]);
    }
  }
}

customElements.define('product-gallery', ProductGallery);


var elem = document.querySelector('.product-gallery__nav');
if(elem){
var flkty = new Flickity( elem, {  
  //autoPlay: 2000,  
  draggable:true,
  wrapAround: false,resize: true,
  freeScroll: false,imagesLoaded: true,
  prevNextButtons: false,contain: true,
  pageDots: false,adaptiveHeight: false,
  percentPosition: true,
  cellAlign: 'left'  
});
  }